export default {
    draft: 'draft',
    filter: {
        filterMenu: {
            title: 'Filter selection: {title}',
            submit: 'Apply',
            close: 'Close',
            search: 'Search'
        }
    },
    columns: {
        selected: 'Selection'
    }
}
